//External
import React, { useState, useEffect } from "react";
import { Form, Button } from "react-bootstrap";
//Internal
import OtpInputBox from "../../components/login/otp-input";
import ResenOtp from "./ResenOtp";
import { REQUIRE_OTP } from "utils";
import verifyImg from "../../public/assets/images/verification-number.svg";

/*******************
  @Purpose : used for category
  @Parameter : { phoneNumber, handleOtpSUbmit, resendOtp, error }
  @Author : INIC
  *******************/
function OtpVerification({
  phoneNumber,
  handleOtpSUbmit,
  resendOtp,
  error,
  showOtpBlock,
}) {
  const { contact_number, country_code } = phoneNumber;
  const [otp, setOtp] = useState("");
  const [errorMessage, setErrorMessage] = useState(error);
  const [clickCount, setClickCount] = useState(1);
  const [otpEnable, setOtpEnable] = useState(false);

  /*******************
  @Purpose : If error coming then setOtp false
  @Parameter : { error }
  @Author : INIC
  *******************/
  useEffect(() => {
    if (error) {
      setErrorMessage(error);
      setOtpEnable(false);
    }
  }, [error]);

  /*******************
  @Purpose : used for handle OTP send
  @Parameter : { otp }
  @Author : INIC
  *******************/
  const handleChange = (otp) => {
    setErrorMessage("");
    setOtp(otp);
    if (otp.length == 6) {
      setOtpEnable(true);
      handleOtpSUbmit(otp);
    }
  };

  /*******************
  @Purpose : Click on verify btn
  @Parameter : {otp}
  @Author : INIC
  *******************/
  const verifyClickHandler = (otp) => {
    if (otp) {
      if (otp.length == 6) {
        handleOtpSUbmit(otp);
      } else {
        setOtpEnable(false);
        setErrorMessage(REQUIRE_OTP);
      }
    } else {
      setErrorMessage(REQUIRE_OTP);
    }
  };

  const handleClickCount = () => {
    setClickCount(clickCount + 1);
  };

  /*******************
  @purpose : Render HTML/ React Components
  @Author : INIC
  ******************/
  return (
    <section className="login-otp 123">
      <div className="otp-card border-0">
        <div className="otp-card-banner p-0">
          <div className="otp-title-box">
            <h4>Verification Code</h4>
            <p>
              sent to <span>{`${country_code} ${contact_number}`}</span>
            </p>
          </div>
          <img
            src={verifyImg}
            alt="otp banner image"
            width="auto"
            height="auto"
            className="otp-img-web"
          />
        </div>
        <div className="otp-card-body p-0 mt-3">
          <div className="otp-title-box">
            <h4>Verification Code</h4>
            <p>
              sent to <span>{`${country_code} ${contact_number}`}</span>
            </p>
          </div>
          {/* Form */}
          <Form className="text-left">
            <legend>ENTER VERIFICATION CODE</legend>

            <OtpInputBox
              handleChange={handleChange}
              otp={otp}
              clickCount={clickCount}
              otpEnable={otpEnable}
              autofocus
            />

            <ResenOtp
              resendOtp={(data) => {
                setOtp("");
                setErrorMessage("");
                setOtpEnable(false);
                resendOtp(data);
              }}
              phoneNumber={phoneNumber}
              handleClickCount={handleClickCount}
            />

            <span className="text-danger font-12 ff-hel-med text-left mb-1 d-block">
              {errorMessage}
            </span>
            <Button
              variant="primary"
              type="button"
              className="w-100 font-16 ff-hel-med text-uppercase verify-btn"
              onClick={() => verifyClickHandler(otp)}
            >
              verify
            </Button>
          </Form>
        </div>
      </div>
    </section>
  );
}

export default OtpVerification;
